export enum SuggestedGcpType {
  ADD_NEW = "ADD_NEW",
  SEND_COORDINATES = "SEND_COORDINATES",
}

export enum CorruptedGcpType {
  REPLACE_BROKEN = "REPLACE_BROKEN",
  REPLACE_SMALL = "REPLACE_SMALL",
  CLEANUP_STUFF = "CLEANUP_STUFF",
  CLEANUP_DIRT = "CLEANUP_DIRT",
  CLEANUP_REPAINT = "CLEANUP_REPAINT",
  FIX_COORDINATES = "FIX_COORDINATES",
  CHECK_CONDITION = "CHECK_CONDITION",
  OTHER = "OTHER",
}

export enum PlacementStatus {
  COMPLETED = "COMPLETED",
  UNCOMPLETED = "UNCOMPLETED",
}

export interface ICoordinates {
  x: number;
  y: number;
}

interface ICoordinates3d extends ICoordinates {
  z: number;
}

export interface ISuggestedGcp {
  id: string;
  type: SuggestedGcpType;
  tsCreated?: number;
  createdBy?: string;
  coordinates: ICoordinates;
  tsPlaced?: string;
  placedBy?: string;
  placementStatus: PlacementStatus;
}

export interface ICorruptedGcp {
  id: string;
  flightMarkerId: string;
  type: CorruptedGcpType;
  tsCreated?: number;
  createdBy?: string;
  tsPlaced?: string;
  placedBy?: string;
  placementStatus: PlacementStatus;
}

export interface IExistingGcp {
  id: string;
  name: string;
  tsCreated?: number;
  createdBy?: string;
  coordinates: ICoordinates3d;
  originalCoordinates: ICoordinates3d | null;
  measurementGuideComment: string;
  highPriority: boolean;
}

export enum GcpRequestInstruction {
  REMEASURE = "REMEASURE",
}

export interface IGCPRequestV2 {
  status: "OPEN" | "CLOSED";
  customer: string;
  site: string;
  createdAt: string; // ISO datetime
  createdBy?: string;
  // scan date as in '2023-08-22', or 'maiden', or 'satellite-maiden-2026-08-10', or null
  scan: string | null;
  recipientsType?: "CS" | "OPS" | "CLIENT";
  recipients: string[];
  placementResponsibility?: string[];
  suggested: ISuggestedGcp[];
  corrupted: ICorruptedGcp[];
  existing: IExistingGcp[];
  // map of marker id to instruction array
  instructions: Record<string, GcpRequestInstruction[]>;
  commentForPilot?: string;
}
